import { apiClient } from "@/lib/api/client";
import { ENDPOINTS } from "@/lib/api/config";

export interface RoundupSection {
  theme?: string;
  heading?: string;
  body_text: string;
  body_html?: string;
  stash_ids: string[];
  entity_ids?: string[];
}

export interface RoundupSummary {
  roundup_id: string;
  subject: string;
  published_at: string;
  summary?: string;
  themes?: string[];
  stash_count: number;
  section_count: number;
  cover_stash_id?: string;
}

export interface RoundupDetail extends RoundupSummary {
  sections: RoundupSection[];
  prev_roundup_id?: string | null;
  next_roundup_id?: string | null;
}

export interface RoundupListResponse {
  roundups: RoundupSummary[];
  next_cursor?: string | null;
}

export interface RoundupDetailResponse {
  roundup: RoundupDetail;
}

export interface RoundupActivity {
  stash_count: number;
  place_count: number;
  event_count: number;
  since: string | null;
  has_roundups: boolean;
}

class RoundupsService {
  async listRoundups(limit = 20, cursor?: string | null): Promise<RoundupListResponse> {
    const params = new URLSearchParams();
    if (limit) params.set("limit", String(limit));
    if (cursor) params.set("cursor", cursor);
    const query = params.toString() ? `?${params.toString()}` : "";
    return apiClient.get<RoundupListResponse>(`${ENDPOINTS.ROUNDUPS.LIST}${query}`);
  }

  async getRoundup(roundupId: string): Promise<RoundupDetailResponse> {
    return apiClient.get<RoundupDetailResponse>(ENDPOINTS.ROUNDUPS.GET(roundupId));
  }

  async getActivity(): Promise<RoundupActivity> {
    return apiClient.get<RoundupActivity>(ENDPOINTS.ROUNDUPS.ACTIVITY);
  }
}

export const roundupsService = new RoundupsService();
